// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body-select[data-v-308661db]{width:100%}.icon-info[data-v-308661db]{font-size:20px;padding:5px 0 0 30px}.body-icon-info[data-v-308661db]{font-size:20px;padding:5px 0 0 0}.block-inputs[data-v-308661db]{margin-top:56px}.body-checkbox[data-v-308661db]{margin-right:10px}.block-inputs[data-v-308661db]{margin:36px 0 0 15px}.inputs[data-v-308661db]{width:90%}.inputs .select-inputs[data-v-308661db]{width:60px}.inputs .select-inputs-big[data-v-308661db]{width:100px}", ""]);
// Exports
module.exports = exports;
